module.exports = __webpack_public_path__ + "img/shouhuo.129791f1.jpg";